import { createActionType, createApiActionType } from 'app/store/utils';

const type = createActionType('multiJoin');
const apiType = createApiActionType('multiJoin');

export const INITIALIZE = type('Initialize');
export const INITIALIZE_CONFIG = type('InitializeConfig');

export const ADD_SOURCE = type('AddSource');
export const REMOVE_SOURCE = type('RemoveSource');
export const SELECT_SOURCE = type('SelectSource');
export const REORDER_SOURCES = type('ReorderSources');

export const SELECT_KEY = type('SelectKey');

export const REMOVE_CRITERIA = type('RemoveCriteria');
export const CHANGE_CRITERIA = type('ChangeCriteria');
export const CHANGE_JOIN_TYPE = type('ChangeJoinType');

export const PREVIEW = type('Preview');

export const CREATE = apiType('Create');
export const UPDATE = apiType('Update');

export const CHANGE_COLUMN_SELECTION = type('ChangeColumnSelection');
export const RENAME_COLUMN = type('RenameColumn');

export const REMOVE_COLUMNS = type('RemoveColumns');

export const CALCULATE_UNMATCHED_ROWS = apiType('CalculateUnmatchedRows');
export const CALCULATE_MULTIPLICATION_FACTOR = apiType('CalculateMultiplicationFactor');
export const CHANGE_TAB = type('ChangeTab');
